import { Alert } from '@commenda/kakashi';
import { useState } from 'react';

export const AlertComponent = ({
  message,
  type,
  dismissible = true,
  props = {},
}: {
  message: string;
  type: string;
  dismissible?: boolean;
  props?: {
    message?: string;
    type?: string;
    dismissible?: boolean;
  };
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const {
    message: messageProp,
    type: typeProp,
    dismissible: dismissibleProp,
  } = props;
  if (!isVisible) return null;

  const variantMap = {
    info: 'info',
    warning: 'warning',
    error: 'destructive',
    success: 'success',
  };

  // if (!(messageProp || typeProp) || !(message || type)) {
  //   return null;
  // }

  return (
    <Alert
      variant={variantMap[typeProp || type] || 'default'}
      title=""
      description={messageProp || message}
      onClose={
        dismissibleProp || dismissible ? () => setIsVisible(false) : undefined
      }
      _className="mb-4"
    />
  );
};
